<div class="page-segments">

   <section class="options desktop">
      <div class="container">
         <div class="row">
            <div class="col-md-3" *ngFor="let segmentacao of segmentacoes; let i = index;">
               <div class="option {{i <= 2 ? 'opt-border': ''}} {{segmentacao.opcao === 2 ? 'exclusive' : segmentacao.opcao === 3 ? 'plus' : segmentacao.nome === 'Eco_EC<br/>O' ? 'eco' : ''}}">
                  <a [routerLink]="['/decorar-apartamento']" [state]="{selectedSegment: segmentacao.id}">
                     <div *ngIf="segmentacao.opcao === 2" class="favorite">
                        <span>&#9733; Favorito</span>
                     </div>
                     <div *ngIf="segmentacao.opcao === 3" class="favorite plus">
                        <span>&#9733; Mais Escolhido</span>
                     </div>
                     <div class="title">
                        <h1 class="normal" [innerHTML]="getNome(segmentacao.nome, 'normal')"></h1>
                        <h1 class="hover" [innerHTML]="getNome(segmentacao.nome, 'hover')"></h1>
                     </div>
                     <div class="items">
                        <p [innerHTML]="segmentacao.descricao"></p>
                     </div>
                     <div class="price">
                        <p>Valor do apartamento:<br/>{{segmentacao.preco | currency: 'BRL': true}}</p>
                     </div>
                  </a>
               </div>
            </div>
         </div>
      </div>
   </section>
   
   <section class="options mobile">
      <div class="container">
         <div class="row">
            <div class="col-md-12">
               <owl-carousel-o [options]="carouselOptions">
                  <ng-template carouselSlide *ngFor="let segmentacao of segmentacoes; let i = index;">
                     <div class="option {{i <= 2 ? 'opt-border': ''}} {{segmentacao.opcao === 2 ? 'exclusive' : segmentacao.opcao === 3 ? 'plus' : segmentacao.nome === 'Eco_EC<br/>O' ? 'eco' : ''}}">
                        <a [routerLink]="['/decorar-apartamento']" [state]="{selectedSegment: segmentacao.id}">
                           <div *ngIf="segmentacao.opcao === 2" class="favorite">
                              <span>&#9733; Favorito</span>
                           </div>
                           <div *ngIf="segmentacao.opcao === 3" class="favorite plus">
                              <span>&#9733; Mais Escolhido</span>
                           </div>
                           <div class="title">
                              <h1 class="normal" [innerHTML]="getNome(segmentacao.nome, 'normal')"></h1>
                              <h1 class="hover" [innerHTML]="getNome(segmentacao.nome, 'hover')"></h1>
                           </div>
                           <div class="items">
                              <p [innerHTML]="segmentacao.descricao"></p>
                           </div>
                           <div class="price">
                              <p>Valor do apartamento:<br/>{{segmentacao.preco | currency: 'BRL': true}}</p>
                           </div>
                        </a>
                     </div>
                  </ng-template>
              </owl-carousel-o>
            </div>
         </div>
      </div>
   </section>
</div>

<ng-template #configuratorAlertModal>
   <div class="modal-body page-segments">
      <p class="text">Antes de configurar o seu novo apartamento, escolha a melhor opção para você.</p>
      <p class="button"><a href="javascript:void(0);" (click)="modalRef.hide()" class="link-configurator">Começar <img src="assets/images/arrow-right-white.png" /></a></p>
   </div>
</ng-template>